import NavBar from "./NavBar";
import { Box, CssBaseline, ThemeProvider } from "@mui/material";
import { theme } from "../theme/theme";
import { ReactNode, useEffect } from "react";
import { useConditionalStylesheets } from "../hooks/useConditionalStylesheets";
import { AppNavBar } from "./AppNavBar";

type PageProps = {
    children: ReactNode
}

export const AppLayout = ({ children }: PageProps) => {
    useConditionalStylesheets();
    
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <div id="app" className="d-flex flex-column h-100">
                <AppNavBar />
                <Box sx={{ display: "flex", flexDirection: "column", flex: "1", overflow: "auto", marginLeft: "240px", transition: "margin-left 0.5s", [`@media (max-width: 900px)`]: { marginLeft: "60px" } }}>
                    <Box sx={{ height: "44px", minHeight: "44px" }}></Box>
                    {children}
                </Box>
            </div>
        </ThemeProvider>
    );
};
